// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 2462 ? "react-monaco-editor" : chunkId) + "." + {"2462":"62a553fe","3793":"a84589d7"}[chunkId] + ".chunk.css";
};